<template>
	<ClientOnly>
		<template v-if="mode && mode == 'detail'">
			<BaseCatalogSetWishlist v-slot="{active, onToggleWishlist, loading, message}" :item="item">
				<div class="cd-wishlist" :class="{'wishlist-detail-buttons': mode == 'wishlist','active': active,}" >
					<div class="cd-wishlist-btn" 
						:class="[{
							'wishlist-detail-btn': mode == 'wishlist',
							'wishlist-detail-btn-remove': mode == 'wishlist' && active,
							'cd-wishlist-add': !active,
							'cd-wishlist-remove': active,
							'loading': loading
						}]" 
						@click="onToggleWishlist(mode);"
					>
						<BaseCmsLabel v-if="!active" code="add_to_wishlist" tag="span" />
						<BaseCmsLabel tag="span" code="remove_from_wishlist"  v-if="active" />
						<BaseCmsLabel class="product-in-wishlist cd-wishlist-message wishlist_message wishlist-message set-wishlist-message" v-show="message" :code="message" tag="span" />
					</div>
				</div>
			</BaseCatalogSetWishlist>
		</template>
		<template v-else>
			<BaseCatalogSetWishlist v-slot="{active, onToggleWishlist, loading, message}" :item="item">
				<div class="cp-wishlist" :class="[{'active': active || mode == 'wishlist'}, mode]" >
					<div class="cp-wishlist-btn" 
						:class="[{
							'cp-wishlist-add': !active,
							'cp-wishlist-remove': active || mode == 'wishlist',
							'loading': loading
						}]" 
						@click="onToggleWishlist(mode);"
					>
						<span>
							<BaseCmsLabel v-if="!active" code="add_to_wishlist" />
							<template v-else>
								<BaseCmsLabel v-if="mode && mode === 'wishlist'" code="remove_from_wishlist" />
								<BaseCmsLabel v-else code="wishlist" />
							</template>
						</span>
						<BaseCmsLabel class="product-in-wishlist wishlist-message" v-show="message" :code="message" tag="span" />
					</div>
				</div>
			</BaseCatalogSetWishlist>
		</template>
	</ClientOnly>
</template>

<script setup>
	const props = defineProps(['item','mode']);
</script>

<style lang="less" scoped>
	.instashop{
		position: relative; top: unset; right: unset; width: 48px; height: 48px; border: 1px solid var(--borderColor); flex-shrink: 0; border-radius: 2px;
		.cp-wishlist-btn{display: flex!important; align-items: center; justify-content: center; width: 100%; height: 100%;}
		.wishlist-message{right: 4px;}
		@media (max-width: @m){width: 40px; height: 40px;}
	}
</style>